import { HeaderSettings } from './types';

export const DEFAULT_HEADER_SETTINGS: HeaderSettings = {
  isVisibleBackButton: true,
  isActiveRightButton: true,
};
